import { Component, ChangeDetectionStrategy, inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { HomeHeroCarouselComponent } from './home-hero-carousel/home-hero-carousel.component';
import { HomeWhyChooseUsComponent } from './home-why-choose-us/home-why-choose-us.component';
import { HomeLocationsComponent } from './home-locations/home-locations.component';
import { HomeExperiencesComponent } from './home-experiences/home-experiences.component';
import { HomeMaterialsComponent } from './home-materials/home-materials.component';
import { HomeTestimonialsComponent } from './home-testimonials/home-testimonials.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    HomeHeroCarouselComponent,
    HomeWhyChooseUsComponent,
    HomeLocationsComponent,
    HomeExperiencesComponent,
    HomeMaterialsComponent,
    HomeTestimonialsComponent,
    // Other sections added here later
  ],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent {
  private platformId = inject(PLATFORM_ID);

  scrollToExperiences() {
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('experiences')?.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
